import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { Autocomplete, TextField } from '@mui/material';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Decimal from 'decimal.js';


const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {


  const [formData, setFormData] = useState({
    name: null,
    email: null,
    entityName: null,
    mobile: null,
    password: null,
    parentId: null,
    balance: null,
    balanceCap: null,
    regDate: null,
    panNumber: null,
    nameOnAadhaar: null,
    nameOnPan: null,
    aadharNumber: null,
    aadharMask: null,
    status: null,
    approval: null,
    userType: 'operator',
    uniqueId: null,
    gstNo: null,
    tanNumber: null,
    address: null,
    portId: null,
    otp: null,

  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: { id: value } });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.name === '' || formData.name === null) {
      formErrors.name = 'Name cannot be empty';
    }

    if (formData.email === '' || formData.email === null) {
      formErrors.email = 'Email cannot be empty';
    }
    else {
      if (!/\S+@\S+\.\S+/.test(formData.email)) {
        formErrors.email = 'Format Is Wrong Ex: example@gmail.com';
      }
    }


    // if (formData.entityName === '') {
    //   formErrors.entityName = 'Entity Name cannot be empty';
    // }

    if (formData.mobile === '' || formData.mobile === null) {
      formErrors.mobile = 'Mobile cannot be empty';
    }

    // if (formData.password === '') {
    //   formErrors.password = 'Password cannot be empty';
    // }

    // if (formData.parentId === null) {
    //   formErrors.parentId = 'Parent ID cannot be null';
    // }

    // if (formData.balance === '') {
    //   formErrors.balance = 'Balance cannot be zero';
    // }

    // if (formData.balanceCap === '') {
    //   formErrors.balanceCap = 'Balance Cap cannot be zero';
    // }
    // if (formData.regDate === '') {
    //   formErrors.regDate = 'regDate Cap cannot be zero';
    // }

    if (formData.panNumber === '' || formData.panNumber === null) {
      formErrors.panNumber = 'PAN Number cannot be empty';
    }

    // if (formData.nameOnAadhaar === '' || formData.nameOnAadhaar === null) {
    //   formErrors.nameOnAadhaar = 'Name on Aadhaar cannot be empty';
    // }

    if (formData.nameOnPan === '' || formData.nameOnPan === null) {
      formErrors.nameOnPan = 'Name on PAN cannot be empty';
    }

    // if (formData.aadharNumber === '' || formData.aadharNumber === null) {
    //   formErrors.aadharNumber = 'Aadhaar Number cannot be empty';
    // }

    if (formData.gstNo === "" || formData.gstNo === null) {
      formErrors.gstNo = 'GST Number cannot be empty';
    }

    if (formData.tanNumber === '' || formData.tanNumber === null) {
      formErrors.tanNumber = 'TAN Number cannot be empty';
    }
    // if (formData.aadharMask === '') {
    //   formErrors.aadharMask = 'aadharMask cannot be empty';
    // }

    // if (formData.status === '') {
    //   formErrors.status = 'Status cannot be empty';
    // }

    // if (formData.userType === '') {
    //   formErrors.userType = 'User Type cannot be empty';
    // }
    // if (formData.uniqueId === '') {
    //   formErrors.uniqueId = 'uniqueId cannot be empty';
    // }

    // if (formData.gstNo === '') {
    //   formErrors.gstNo = 'GST Number cannot be empty';
    // }

    // if (formData.tanNumber === '') {
    //   formErrors.tanNumber = 'TAN Number cannot be empty';
    // }

    if (formData.address === '' || formData.address === null) {
      formErrors.address = 'Address cannot be empty';
    }
    // if (formData.portId === null || formData.portId === '') {
    //   formErrors.portId = 'portId cannot be empty';
    // }
    // if (formData.otp === '') {
    //   formErrors.otp = 'otp cannot be empty';
    // }


    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  // const formattedAmount1 = parseFloat(formData.balance).toFixed(2)
  // const formattedAmount2 = parseFloat(formData.balanceCap).toFixed(2)

  const Alldata = {
    parentId: null ,
    portId: {
      id: formData.portId
    },

    name: formData.name || null,
    email: formData.email || null,
    entityName: formData.entityName || null,
    mobile: formData.mobile || null,
    password: formData.password,
    // balance: parseInt(formData.balance) || 0.00,
    // balanceCap: parseInt(formData.balanceCap) || 0.00,

    balance: new Decimal(formData.balance ? formData.balance : 0.00).toFixed(2) || 0.00,
    balanceCap: new Decimal(formData.balanceCap ? formData.balanceCap : 0.00).toFixed(2) || 0.00,

    regDate: formData.regDate,
    panNumber: formData.panNumber ? formData.panNumber.toUpperCase() : null,
    nameOnAadhaar: formData.nameOnAadhaar || null,
    nameOnPan: formData.nameOnPan || null,
    aadharNumber: formData.aadharNumber || null,
    aadharMask: formData.aadharMask,
    status: formData.status ? formData.status : 'active',
    approval: formData.approval ? formData.approval : 'pending',
    userType: 'operator',
    uniqueId: formData.uniqueId || null,
    gstNo: formData.gstNo || null,
    tanNumber: formData.tanNumber || null,
    address: formData.address || null,
    otp: formData.otp || null,
  };

  // console.log("parent id data", Alldata)
  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/users/add', Alldata, {

        headers: {
          'access_token': token,
        },

      });

      if (response.data.Status === "SUCCESS") {
        setFormData({
          name: null,
          email: null,
          entityName: null,
          mobile: null,
          password: null,
          parentId: null,
          balance: null,
          balanceCap: null,
          regDate: null,
          panNumber: null,
          nameOnAadhaar: null,
          nameOnPan: null,
          aadharNumber: null,
          aadharMask: null,
          status: null,
          approval: null,
          userType: 'operator',
          uniqueId: null,
          gstNo: null,
          tanNumber: null,
          address: null,
          portId: null,
          otp: null,
        });
        toggle(); // Close the modal after submission
        toast.success(response.data.message)

      }
      else {
        toast.error(response.data.message)
        console.log(response.data.message)
      }
    }
    catch (error) {
      toast.error(error.response.data.message)
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');

      // window.location.reload();
    }
  };

  // ************************************************ Get port Data ***********************************************************
  const [data, setData] = useState([]);

  const fetchPortId = async () => {
    try {
      const response = await apiClient.get(`/api/admin/port/getAll`, {
        params: {
          pageNumber: 0,
          pageSize: 200,
        },
        headers: {
          'access_token': token,
        }
      }
      );
      setData(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData = Array.from(
    new Map(data.map((item) => [item.name, item])).values()
  );

  const validData = filteredData.filter((item) => item.name);



  // ************************************************ Get Admin Type Data ***********************************************************
  const [data2, setData2] = useState([]);

  const fetchParentId = async () => {
    try {
      const response = await apiClient.get("/api/admin/users/getByUserType", {
        params: {
          userType: "admin",
          pageNumber: 0,
          pageSize: 200,
        },
        headers: {
          'access_token': token,
        }
      }
      );
      setData2(response.data.data.records);

    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const filteredData2 = Array.from(
    new Map(data2.map((item) => [item.name, item])).values()
  );

  const validData2 = filteredData2.filter((item) => item.name);



  useEffect(() => {
    fetchParentId()
    fetchPortId()

  }, []);



  return (
    <>
      {show && (
        <>

          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Operator</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="name" className="label-custom">Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.name ? 'input-error' : ''}`}
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]{0,50}$/.test(value)) { // Only alphabetic characters, max 50 characters
                              handleChange(e);
                            }
                          }}
                          maxLength="50"  // Set max length to 50
                        />
                        {errors.name && <span className="text-danger">{errors.name}</span>}
                      </div>

                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="email" className="label-custom">Email</label>
                        <input
                          type="email"
                          className={`input-custom ${errors.email ? 'input-error' : ''}`}
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && <span className="text-danger">{errors.email}</span>}

                      </div>
                    </div>

                    <div className='row w-100'>
                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="entityName" className="label-custom">Entity Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.entityName ? 'input-error' : ''}`}
                          id="entityName"
                          name="entityName"
                          value={formData.entityName}
                          onChange={handleChange}
                        />
                      </div> */}

                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="mobile" className="label-custom">Mobile Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.mobile ? 'input-error' : ''}`}
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              handleChange(e); // Sirf numeric aur max 12 digits ki value allow karega
                            }
                          }}
                          maxLength="10"

                        />
                        {errors.mobile && <span className="text-danger">{errors.mobile}</span>}

                      </div>

                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="panNumber" className="label-custom">Pan Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.panNumber ? 'input-error' : ''}`}
                          id="panNumber"
                          name="panNumber"
                          value={formData.panNumber ? formData.panNumber.toUpperCase() : ''}
                          onChange={handleChange}
                          maxLength="10"
                        />
                        {errors.panNumber && <span className="text-danger">{errors.panNumber}</span>}

                      </div>



                    </div>

                    <div className='row w-100'>
                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="password" className="label-custom">Password</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.password ? 'input-error' : ''}`}
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                      </div> */}


                      {/* <label htmlFor="parentId" className="label-custom">Parent</label>
                        <Autocomplete
                          className={` ${errors.parentId ? 'input-error' : ''}`}
                          disablePortal
                          options={validData2} // Full user object
                          getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, parentId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, parentId: "" }); // Reset state 
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.name}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '110px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        /> */}


                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="tanNumber" className="label-custom">Tan Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.tanNumber ? 'input-error' : ''}`}
                          id="tanNumber"
                          name="tanNumber"
                          value={formData.tanNumber}
                          onChange={handleChange}
                          maxLength="10"

                        />
                        {errors.tanNumber && <span className="text-danger">{errors.tanNumber}</span>}

                      </div>

                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="nameOnPan" className="label-custom">Pan Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.nameOnPan ? 'input-error' : ''}`}
                          id="nameOnPan"
                          name="nameOnPan"
                          value={formData.nameOnPan}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]{0,50}$/.test(value)) { // Only alphabetic characters, max 50 characters
                              handleChange(e);
                            }
                          }}
                          maxLength="50"  // Set max length to 50
                        />
                        {errors.nameOnPan && <span className="text-danger">{errors.nameOnPan}</span>}

                      </div>

                      {/* <div className="spacing w-50 d-inline-block">
                        <label htmlFor="parentId" className="label-custom">Selected Admin</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.parentId ? 'input-error' : ''}`}
                          id="parentId"
                          name="parentId"
                          value={selectedAdmin}
                        />
                      </div> */}





                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="balance" className="label-custom">Balance</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.balance ? 'input-error' : ''}`}
                          id="balance"
                          name="balance"
                          value={formData.balance}
                          onChange={handleChange}
                          onInput={(e) => {
                            // Allow digits and a single decimal point
                            e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                            // Prevent more than one decimal point
                            if ((e.target.value.match(/\./g) || []).length > 1) {
                              e.target.value = e.target.value.replace(/\.+$/, '');
                            }
                          }}
                        />
                        {errors.balance && <span className="text-danger">{errors.balance}</span>}

                      </div>

                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="balanceCap" className="label-custom">Balance Cap</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.balanceCap ? 'input-error' : ''}`}
                          id="balanceCap"
                          name="balanceCap"
                          value={formData.balanceCap}
                          onChange={handleChange}
                          onInput={(e) => {
                            // Allow digits and a single decimal point
                            e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                            // Prevent more than one decimal point
                            if ((e.target.value.match(/\./g) || []).length > 1) {
                              e.target.value = e.target.value.replace(/\.+$/, '');
                            }
                          }}
                        />
                        {errors.balanceCap && <span className="text-danger">{errors.balanceCap}</span>}

                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="gstNo" className="label-custom">GST Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.gstNo ? 'input-error' : ''}`}
                          id="gstNo"
                          name="gstNo"
                          value={formData.gstNo}
                          onChange={handleChange}
                        />
                        {errors.gstNo && <span className="text-danger">{errors.gstNo}</span>}

                      </div>

                      <div className="spacing w-50 d-inline-block" >
                        {/* <label htmlFor="userType" className="label-custom">User Type</label>
                        <select
                          className={`form-select ${errors.userType ? 'input-error' : ''}`}
                          id="userType"
                          name="userType"
                          value={formData.userType}
                          onChange={handleChange}
                        >
                          <option value="">Select User Type</option>
                          <option value="admin">Admin</option>
                          <option value="editor">Operator</option>
                          <option value="viewer">User</option>
                        </select> */}

                        <label htmlFor="address" className="label-custom">Address</label>
                        <textarea
                          className={`input-custom ${errors.address ? 'input-error' : ''}`}
                          id="address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          rows="1" // You can adjust the number of rows as needed
                        // placeholder="Enter your address" // Optional placeholder
                        />
                        {errors.address && <span className="text-danger">{errors.address}</span>}

                      </div>

                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="regDate" className="label-custom">Register Date</label>
                        <input
                          type="date"
                          className={`input-custom ${errors.regDate ? 'input-error' : ''}`}
                          id="regDate"
                          name="regDate"
                          value={formData.regDate}
                          onChange={handleChange}
                        />
                      </div> */}



                      {/* <div className="spacing w-50 d-inline-block">

                        <label htmlFor="portId" className="label-custom">Port</label>
                        <Autocomplete
                          className={` ${errors.portId ? 'input-error' : ''}`}
                          disablePortal
                          options={validData} // Full user object
                          getOptionLabel={(option) => option.name} // Show 'name' in dropdown
                          getOptionSelected={(option, value) => option.id === value.id} // Ensure unique selection
                          renderInput={(params) => <TextField {...params} label="" />}
                          onChange={(event, value) => {
                            if (value) {
                              setFormData({ ...formData, portId: value.id }); // Save 'id' in state
                            } else {
                              setFormData({ ...formData, portId: "" }); // Reset state
                            }
                          }}
                          // Key attribute setup using 'id'
                          renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                              {option.name}
                            </li>
                          )}
                          // Scroll enable kare inline style ke sath
                          componentsProps={{
                            paper: {
                              style: {
                                maxHeight: '130px', // Dropdown ki maximum height
                                overflowY: 'auto',  // Scroll enable karega
                              },
                            },
                          }}
                        />
                        {errors.portId && <span className="text-danger">Port is required</span>}

                      </div> */}

                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="approval" className="label-custom">Approval</label>
                        <select
                          className={`form-select`}
                          id="approval"
                          name="approval"
                          value={formData.approval}
                          onChange={handleChange}
                        >
                          <option value="">Select Approval</option>
                          <option value="approved">Approved</option>
                          <option value="pending">Pending</option>
                          <option value="rejected">Rejected</option>
                        </select>
                      </div> */}

                    </div>

                    <div className='row w-100'>
                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="nameOnAadhaar" className="label-custom"> Aadhaar Name</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.nameOnAadhaar ? 'input-error' : ''}`}
                          id="nameOnAadhaar"
                          name="nameOnAadhaar"
                          value={formData.nameOnAadhaar}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[A-Za-z\s]{0,50}$/.test(value)) { // Only alphabetic characters, max 50 characters
                              handleChange(e);
                            }
                          }}
                          maxLength="50"  // Set max length to 50
                        />
                        {errors.nameOnAadhaar && <span className="text-danger">Aadhaar Name is required</span>}

                      </div> */}


                    </div>

                    <div className='row w-100'>
                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="aadharNumber" className="label-custom">Aadhaar Number</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.aadharNumber ? 'input-error' : ''}`}
                          id="aadharNumber"
                          name="aadharNumber"
                          value={formData.aadharNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,12}$/.test(value)) {
                              handleChange(e); // Sirf numeric aur max 12 digits ki value allow karega
                            }
                          }}
                          maxLength="12"
                        />
                        {errors.aadharNumber && <span className="text-danger">Aadhaar Number is required</span>}

                      </div> */}
                      {/* <div className="spacing w-50 d-inline-block">
                        <label htmlFor="status" className="label-custom">Status</label>
                        <select
                          className={`form-select ${errors.status ? 'input-error' : ''}`}
                          id="status"
                          name="status"
                          value={formData.status}
                          onChange={handleChange}
                        >
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                          <option value="Inactive">InActive</option>
                          <option value="failed">Failed</option>
                        </select>
                      </div> */}

                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="aadharMask" className="label-custom">Aadhaar Mask</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.aadharMask ? 'input-error' : ''}`}
                          id="aadharMask"
                          name="aadharMask"
                          value={formData.aadharMask}
                          onChange={handleChange}
                        />
                      </div> */}
                    </div>

                    <div className='row w-100'>




                    </div>

                    <div className='row w-100'>


                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="uniqueId" className="label-custom">Unique Id</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.uniqueId ? 'input-error' : ''}`}
                          id="uniqueId"
                          name="uniqueId"
                          value={formData.uniqueId}
                          onChange={handleChange}
                        />
                      </div> */}
                    </div>

                    <div className='row w-100'>



                    </div>

                    <div className='row w-100'>
                      {/* <div className="spacing w-100 d-inline-block" >

                        <label htmlFor="otp" className="label-custom">OTP</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.otp ? 'input-error' : ''}`}
                          id="otp"
                          name="otp"
                          value={formData.otp}
                          onChange={handleChange}
                        />

                      </div> */}

                      {/* <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="portId" className="label-custom">Port Id</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.portId ? 'input-error' : ''}`}
                          id="portId"
                          name="portId"
                          value={formData.portId.id}
                          onChange={handleChange2}
                        />
                      </div> */}


                      <div className="spacing w-50 d-inline-block">


                      </div>

                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
